.container {
  display: flex;
  flex-direction: column;
  flex: 1;
  max-height: 100%;
}

/* A FLEX BOX THAT CLIPS, not a second scroll container.

   `components/gantt/`'s `.root` is a column flex box whose `.scroller` is `flex: 1;
   min-height: 0` — the ONE scroll container — and that only resolves to the visible height when
   `.root` itself has a DEFINITE one. Under a plain block wrapper it does not: `.root`'s height is
   content-based, so the `flex: 1` scroller grows to the full height of every row and nothing ever
   scrolls inside it. The wrapper scrolls instead, which carries the sticky timeline header off
   the top of the screen and parks the horizontal scrollbar at the bottom of the entire row list
   instead of at the bottom of the viewport.

   `display: flex` stretches `.root` to this box's height; `overflow: hidden` keeps this box out
   of the scrolling business for good. The padding is inside that height, so the chart's own
   horizontal scrollbar sits 1.6rem clear of the bottom edge. */
.chartWrapper {
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding-bottom: 1.6rem;
}

.stageNumber {
  font-size: 1.4rem;
  color: var(--color-surfaces-app-background-0);
  border-radius: 0.4rem;
  background-color: var(--color-texts-high-contrast);
  padding: 0.1rem 0.4rem;
  font-weight: 600;
}
